import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useTranslation } from 'react-i18next';
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import { Grid } from "@mui/material";
import MDTypography from "components/MDTypography";
import DataPointWidget from "components/LH/HC/Panchangaya";
import ChartKendaraya from "components/LH/HC/Chart";
import MatchViewSC from "../components/MatchViewSC";
import MatchViewPT from "../components/MatchViewPT";
import "./match-view.css"
import DateTimePlaceEntry from "components/LH/HC/DateTimePlaceEntry";
import colors from "../../../assets/theme/base/colors"
import { useEffect, useState } from "react";
import MDButton from "components/MDButton";
import { Padding } from "@mui/icons-material";
import React, { useRef } from 'react';
import Utility from "app/horoscope/utility/utility";
import { Link, useParams } from "react-router-dom";
import LHHCApiService from "app/services/LHHCApiService";
import TopNavBar from "app/layout/TopNavBar";
import { useLocation } from "react-router-dom";

function MatchReportView({ }) {
    const apiService = LHHCApiService();
    const { recordId } = useParams();
    const [matchDataRecord, setMatchDataRecord] = useState();
    const [horoscopeDataM, setHoroscopeDataM] = useState();
    const [horoscopeDataF, setHoroscopeDataF] = useState();
    const [mhcDataInput, setMhcDataInput] = useState();
    const [fhcDataInput, setFhcDataInput] = useState();

    const { t } = useTranslation();

    const location = useLocation();

    useEffect(() => {
        if (recordId == undefined) {
            setMatchDataRecord(null);
        }
    }, [location]);

    const onCalculateM = async (hcDataInput) => {
        console.log("hcDataInput", hcDataInput)
        setMhcDataInput(hcDataInput);
    }
    const onCalculateF = async (hcDataInput) => {
        console.log("hcDataInput", hcDataInput)
        setFhcDataInput(hcDataInput);
    }

    useEffect(() => {
        const fetchData = async () => {
            if (recordId) {
                try {
                    const data = await apiService.getMatch(recordId);
                    setHoroscopeDataM(data.maleHCResponseModel);
                    setHoroscopeDataF(data.femaleHCResponseModel);
                    setMatchDataRecord(data.matchData);
                    console.log("matchDataRecord", data.matchData);
                    console.log("horoscopeDataM", data.maleHCResponseModel);
                    console.log("horoscopeDataF", data.femaleHCResponseModel);
                } catch (err) {
                    console.log(err);
                } finally {
                    // setLoading(false);
                }
            } else {
                window.scrollTo(0, 0);
            }
        };

        fetchData();
    }, [recordId]);

    useEffect(() => {
        const fetchData = async () => {
            if (mhcDataInput && fhcDataInput) {
                try {
                    const data = await apiService.addMatch({
                        maleRequest: Utility.getAPIPayLoadForAddHc(mhcDataInput),
                        femaleRequest: Utility.getAPIPayLoadForAddHc(fhcDataInput),
                    });
                    setHoroscopeDataM(data.maleHCResponseModel);
                    setHoroscopeDataF(data.femaleHCResponseModel);
                    setMatchDataRecord(data.matchData);
                } catch (err) {
                    console.log(err);
                } finally {
                    // setLoading(false);
                }
            } else {
                window.scrollTo(0, 0);
            }
        };

        fetchData();
    }, [mhcDataInput, fhcDataInput]);

    const onSubmit = async () => {
        setMhcDataInput(null);
        setFhcDataInput(null);
        maleDTPRef.current.submit();
        femaleDTPRef.current.submit();
    }

    const maleDTPRef = useRef();
    const femaleDTPRef = useRef();

    return (
        <DashboardLayout className="bg-image">
            <TopNavBar />
            <div>&nbsp;</div>
            {!recordId && !matchDataRecord && <>
                <Card className="time-entry" style={{ textAlign: "center", marginBottom: 4 }}>
                    පොරොන්දමක් සෑදීම
                </Card>
                <Card className="time-entry" style={{ backgroundColor: colors.badgeColors.info.background }}>
                    <DateTimePlaceEntry ref={maleDTPRef} onCalculate={onCalculateM} genderDefault={"M"} />
                </Card>
                <Card className="time-entry" style={{ backgroundColor: colors.badgeColors.primary.background }}>
                    <DateTimePlaceEntry ref={femaleDTPRef} onCalculate={onCalculateF} genderDefault={"F"} />
                </Card>
                <Card className="time-entry" style={{ padding: 4 }}>
                    <div className="centent-center">
                        <MDButton xs={12} fullwidth onClick={onSubmit} variant="contained"
                            color="info"
                            size="large">
                            {t("Calculate")}
                        </MDButton>
                    </div>
                </Card>
            </>}
            {matchDataRecord &&
                <>
                    <Card id="start-ref" className="card">
                        <MDBox p={2}>
                            <Grid container spacing={3} alignItems="center" className="centent-center" style={{ width: "100%" }}>
                                <Grid item>
                                    <MDBox height="100%" mt={0.5} lineHeight={1}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            {t('PORONDAM_REPORT')}
                                        </MDTypography>
                                    </MDBox>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </Card>
                    <Card >
                        <Grid container spacing={3} className="centent-center-col">
                            <Grid item md={6} xs={12}>
                                <div className="centent-center-col">
                                    <MDBox height="100%" mt={0.5} lineHeight={1}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            {horoscopeDataM.req.name} - {horoscopeDataM.req.dateTimeLocalString}
                                        </MDTypography>
                                        <MDTypography variant="button" color="text" fontWeight="medium">
                                            {horoscopeDataM.req.location}
                                        </MDTypography>
                                    </MDBox>
                                    <ChartKendaraya devision="D1" gender="M" lagna={horoscopeDataM.lagna} rashiId={horoscopeDataM.rashiId} lagnaSputaya={horoscopeDataM.lagnaSputaya} planets={horoscopeDataM.planet} />
                                </div>
                            </Grid>
                            <Grid item md={6} xs={12} >
                                <div className="centent-center-col">
                                    <MDBox height="100%" mt={0.5} lineHeight={1}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            {horoscopeDataF.req.name} - {horoscopeDataF.req.dateTimeLocalString}
                                        </MDTypography>
                                        <MDTypography variant="button" color="text" fontWeight="medium">
                                            {horoscopeDataF.req.location}
                                        </MDTypography>
                                    </MDBox>
                                    <ChartKendaraya devision="D1" gender="F" lagna={horoscopeDataF.lagna} rashiId={horoscopeDataF.lagnaId} lagnaSputaya={horoscopeDataF.lagnaSputaya} planets={horoscopeDataF.planet} />
                                </div>
                            </Grid>
                        </Grid>
                    </Card>
                    <Card>
                        <Grid container mt={1} ml={0} pl={1} spacing={4} className="centent-center-col">
                            <Grid key="m1" item style={{ paddingTop: 4, paddingLeft: 4, marginBottom: 8 }} xs={6} md={4} lg={2}>
                                <DataPointWidget name={t("DASA") + ' ' + t('PORONDAMA')} value={t('Shuba') + ' ' + matchDataRecord.dps + ' (' + matchDataRecord.dp + '%)'} />
                            </Grid>
                            <Grid key="m2" item style={{ paddingTop: 4, paddingLeft: 4, marginBottom: 8 }} xs={6} md={4} lg={2}>
                                <DataPointWidget name={t("Visi") + ' ' + t('PORONDAMA')} value={t('Shuba') + ' ' + matchDataRecord.vps + ' (' + matchDataRecord.vp / 2 + '%)'} />
                            </Grid>
                            <Grid key="m3" item style={{ paddingTop: 4, paddingLeft: 4, marginBottom: 8 }} xs={6} md={4} lg={2}>
                                <DataPointWidget name={t("KD")} value={matchDataRecord.kd.split("<br>")[0]} />
                            </Grid>
                            <Grid key="m3" item style={{ paddingTop: 4, paddingLeft: 4, marginBottom: 8 }} xs={6} md={4} lg={2}>
                                <DataPointWidget name={t("")} value={matchDataRecord.kd.split("<br>")[1]} />
                            </Grid>

                        </Grid>
                    </Card>
                    <Card >
                        <Grid container spacing={3} className="centent-center-col" style={{ width: "100%" }}>
                            <Grid item xs={12} className="centered-grid-item">

                                <Card xs={{ width: '100%' }} style={{ padding: 0, marginBottom: 8 }}>
                                    <MatchViewPT tableData={matchDataRecord.p10.concat(matchDataRecord.p20)} />
                                </Card>

                            </Grid>
                            <Grid item xs={12}>
                                {matchDataRecord.db.map((item, index) => (
                                    <li key={index} style={{ marginBottom: 8, listStyle: "disc", marginLeft: 24 }}>
                                        {item}
                                    </li>
                                ))}
                            </Grid>
                            <Grid item xs={12} className="centered-grid-item">

                                <MatchViewSC title={t('SudarshanaChakraya')} tableData={matchDataRecord.sc} />
                            </Grid>
                        </Grid>

                    </Card>
                    <Card>
                        <Grid container spacing={3} className="centent-center-col">
                            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", position: "relative", top: 0, marginBottom: 8 }}>
                                <Link
                                    to="/my-files/match/print/:recordId"
                                    state={{ horoscopeDataM, horoscopeDataF, matchDataRecord }}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        textDecoration: "none",
                                        color: "#a00",
                                        gap: 4,
                                        fontWeight: 500
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="currentColor" style={{ marginLeft: 4 }}>
                                        <path d="M19 8H5c-1.1 0-2 .9-2 2v6h4v4h10v-4h4v-6c0-1.1-.9-2-2-2zm-3 10H8v-4h8v4zm3-6H5v-2h14v2zm-2-8H7v4h10V4z" />
                                    </svg>
                                    <span>Print</span>
                                </Link>
                            </div>
                        </Grid>
                    </Card>
                </>
            }
        </DashboardLayout>
    )
}


export default MatchReportView;